"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchTemplateCascade = void 0;
/**
 * Update attributes of a template and then cascade those changes to multiple catalogues. (This will cascade changes to the catalogue_items table for rows that match both the sku and catalogueId.)
 */
var patchTemplateCascade = function (instance) {
    return function (sku, body, config) {
        return instance.patch("/catalogues/templates/".concat(sku, "/cascade"), body, config);
    };
};
exports.patchTemplateCascade = patchTemplateCascade;
